import React from "react";
import { Modal, Button } from "antd";

interface WarningModalProps {
  open: boolean;
  title: React.ReactNode;
  content: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const WarningModal: React.FC<WarningModalProps> = ({
  open,
  title,
  content,
  onConfirm,
  onCancel,
  confirmText = "Yes, Sign Out",
  cancelText = "No",
}) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      onCancel={onCancel}
    >
      <button
        onClick={onCancel}
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          border: "none",
          background: "transparent",
          fontSize: "1.25rem",
          cursor: "pointer",
          color: "#555555",
          paddingRight: '10px'
        }}
        aria-label="Close modal"
      >
        ×
      </button>
      <div className="flex flex-col items-center text-center space-y-4 py-5">

        {/* Exact SVG Icon */}
        <div>
          <svg
            width="60"
            height="60"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="80" height="80" rx="40" fill="#FF9500" fillOpacity="0.2" />
            <rect
              x="3.5"
              y="3.5"
              width="73"
              height="73"
              rx="36.5"
              stroke="#FF9500"
              strokeOpacity="0.05"
              strokeWidth="7"
            />
            <g clipPath="url(#clip0_2075_14532)">
              <path
                d="M41.5958 29.5451C41.4349 29.2649 41.203 29.0321 40.9233 28.8702C40.6437 28.7083 40.3264 28.623 40.0033 28.623C39.6802 28.623 39.3628 28.7083 39.0832 28.8702C38.8036 29.0321 38.5716 29.2649 38.4108 29.5451L27.2681 48.504C26.5255 49.7682 27.416 51.3753 28.8606 51.3753H51.1443C52.5889 51.3753 53.481 49.7666 52.7368 48.504L41.5958 29.5451ZM40 35.1253C40.8694 35.1253 41.5503 35.8761 41.4625 36.7422L40.8938 42.4411C40.8746 42.665 40.7722 42.8735 40.6067 43.0255C40.4412 43.1775 40.2247 43.2618 40 43.2618C39.7753 43.2618 39.5588 43.1775 39.3933 43.0255C39.2278 42.8735 39.1254 42.665 39.1063 42.4411L38.5375 36.7422C38.5171 36.5379 38.5397 36.3315 38.6039 36.1364C38.6681 35.9413 38.7724 35.7618 38.9102 35.6095C39.048 35.4571 39.2161 35.3354 39.4038 35.252C39.5915 35.1686 39.7946 35.1255 40 35.1253ZM40.0033 44.8753C40.4342 44.8753 40.8476 45.0466 41.1523 45.3513C41.457 45.656 41.6283 46.0694 41.6283 46.5003C41.6283 46.9313 41.457 47.3447 41.1523 47.6494C40.8476 47.9541 40.4342 48.1253 40.0033 48.1253C39.5723 48.1253 39.159 47.9541 38.8542 47.6494C38.5495 47.3447 38.3783 46.9313 38.3783 46.5003C38.3783 46.0694 38.5495 45.656 38.8542 45.3513C39.159 45.0466 39.5723 44.8753 40.0033 44.8753Z"
                fill="#FF9500"
              />
            </g>
            <defs>
              <clipPath id="clip0_2075_14532">
                <rect width="26" height="26" fill="white" transform="translate(27 27)" />
              </clipPath>
            </defs>
          </svg>
        </div>

        {/* Content */}
        {title && <div style={{ fontWeight: 'bold', fontSize: 18, color: '#555555' }}>{title}</div>}
        <div style={{ color: 'grey' }}>{content}</div>

        {/* Buttons */}
        <div className="flex justify-end gap-3 mt-4">
          <Button onClick={onCancel}>{cancelText}</Button>
          <Button type="primary" danger onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default WarningModal;
